export enum UserStatus {
  SIGNED_UP = 'SIGNED_UP',
  EMAIL_VERIFIED = 'EMAIL_VERIFIED',
  KYC_PENDING = 'KYC_PENDING',
  KYC_DONE = 'KYC_DONE',
  KYC_REJECTED = 'KYC_REJECTED',
  KYC_VERIFIED = 'KYC_VERIFIED',
}
